import Actions from './components/actions';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import Sliders from './components/sliders';
import myParallax  from './components/parallax';
import Headroom from "headroom.js";

// Fancybox
const fancybox = require('@fancyapps/fancybox');
// Fancybox Stylesheet
const fancyboxCSS = require('@fancyapps/fancybox/dist/jquery.fancybox.css');
 
// select your header or whatever element you wish
const header = document.querySelector("header");
 
const headroom = new Headroom(header);
headroom.init();

new Actions().init();
new Sliders().init();
new myParallax().init();

AOS.init({
    duration: 1000,
    once: true,
});
